import React from 'react';
import { Box, styled } from '@mui/material';
import MiaChat from 'app/NewAIAvatarLayout/features/MiaChat';

const ContentWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

export const GeneratePage: React.FC = () => {
  return (
    // <ContentWrapper>
      <MiaChat view="generate" />
    // </ContentWrapper>
  );
};

